<template>
  <div id="copyright" class="zy_copyright">
    <div class="zy_title zy_copyright_title">版权内容</div>
    <div class="zy_copyright_info">
      <Tabs :tabs="tabs" :currentTab="currentTab" @onClick="handleClick" />
    </div>
    <swiper :options="swiperOptions" ref="mySwiper">
      <swiper-slide v-for="(item, idx) in tabs" :key="item + idx">
        <div class="zy_copyright_detail">
          <p class="zy_copyright_detail_desc" v-for="desc in currentDesc" :key="desc">{{ desc }}</p>
        </div>
        <div class="zy_coryright_pics">
          <div class="marquee-container">
            <div class="marquee-content marquee-animation">
              <!-- 第一组图片 -->
              <div class="pic" v-for="(item, idx) in currentBookList" :key="'first-' + item + idx">
                <img v-lazy="item" />
              </div>
              <!-- 第二组图片（用于无缝循环） -->
              <div class="pic" v-for="(item, idx) in currentBookList" :key="'second-' + item + idx">
                <img v-lazy="item" />
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { COPYRIGHT } from '@/config';
import Tabs from 'vue-tabs-with-active-line';

export default {
  name: 'Copyright',
  components: {
    Tabs
  },
  data: function () {
    const tabs = COPYRIGHT.map(item => ({
      title: item.name,
      value: item.id
    }));
    return {
      COPYRIGHT,
      tabs,
      currentTab: tabs[0].value,
      prevBookList: [],
      swiperOptions: {
        // 角度控制 - 通过touchAngle来控制手势角度
        touchAngle: 15, // 允许的最大角度（度），超过这个角度的手势不会触发滑动
        // 事件监听 - 只保留slideChange事件
        on: {
          slideChange: this.handleSlideChange
        }
      }
    };
  },
  computed: {
    /**
     * 获取swiper实例
     */
    swiper() {
      return this.$refs.mySwiper ? this.$refs.mySwiper.swiper : null;
    },
    currentDesc() {
      return COPYRIGHT.find(item => item.id === this.currentTab)?.desc || '';
    },
    currentBookList() {
      const test = COPYRIGHT.find(item => item.id === this.currentTab)?.pics || [];
      console.log(test);
      return test;
    }
  },
  mounted() {
    /**
     * 组件挂载后确保swiper正确初始化
     */
    this.$nextTick(() => {
      if (this.$refs.mySwiper && this.$refs.mySwiper.swiper) {
        // 确保初始状态正确
        this.$refs.mySwiper.swiper.update();
      }
    });
  },
  watch: {
    /**
     * 监听当前标签变化，同步swiper滑动位置
     */
    currentTab: {
      handler(newVal) {
        this.$nextTick(() => {
          const tabIndex = this.tabs.findIndex(tab => tab.value === newVal);
          if (tabIndex !== -1 && this.swiper) {
            this.swiper.slideTo(tabIndex);
            // 延迟重新启动动画，确保swiper切换完成
            setTimeout(() => {
              this.restartMarqueeAnimation();
            }, 100);
          }
        });
      },
      immediate: false
    }
  },
  methods: {
    handleClick(value) {
      this.$nextTick(() => {
        this.currentTab = value;
        // 重新启动走马灯动画
        this.restartMarqueeAnimation();
      });
    },

    /**
     * 处理swiper滑动变化事件
     * @param {Object} swiper - swiper实例
     */
    handleSlideChange(swiper) {
      // 使用传入的swiper参数或computed属性
      const swiperInstance = swiper || this.swiper;

      // 添加安全检查
      if (!swiperInstance || typeof swiperInstance.activeIndex === 'undefined') {
        return;
      }

      const activeIndex = swiperInstance.activeIndex;

      if (this.tabs[activeIndex]) {
        this.currentTab = this.tabs[activeIndex].value;
        // 重新启动走马灯动画
        this.restartMarqueeAnimation();
      }
    },

    /**
     * 重新启动走马灯动画
     */
    restartMarqueeAnimation() {
      this.$nextTick(() => {
        setTimeout(() => {
          // 查找所有marquee-content元素
          const marqueeContents = this.$el.querySelectorAll('.marquee-content');

          marqueeContents.forEach((content, index) => {
            // 移除动画类
            content.classList.remove('marquee-animation');

            // 强制重排
            content.offsetHeight;

            // 重新添加动画类
            content.classList.add('marquee-animation');

            console.log(`Restarted marquee animation for element ${index}`);
          });
        }, 50); // 延迟50ms确保DOM更新完成
      });
    },

    /**
     * 备用方法：使用CSS类切换重启动画
     */
    restartMarqueeAnimationAlternative() {
      this.$nextTick(() => {
        const marqueeContents = this.$el.querySelectorAll('.marquee-content');

        marqueeContents.forEach((content, index) => {
          // 移除动画类
          content.classList.remove('marquee-animation');

          // 强制重排
          content.offsetHeight;

          // 重新添加动画类
          content.classList.add('marquee-animation');

          console.log(`Alternative method: Restarted marquee animation for element ${index}`);
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/function.scss';

.zy_coryright_pics {
  margin-top: rem(48);
  padding-bottom: rem(72);
  height: rem(321);
  overflow: hidden; // 隐藏超出容器的内容

  .marquee-container {
    width: 100%;
    overflow: hidden;
    position: relative;
  }

  .marquee-content {
    display: flex;
    width: fit-content; // 根据内容自适应宽度
  }

  .marquee-animation {
    animation: marquee 30s linear infinite; // 30秒完成一次循环
  }

  .pic {
    width: rem(240);
    margin: 0 rem(12);
    border-radius: rem(9);
    overflow: hidden;
    flex-shrink: 0; // 防止图片被压缩

    img {
      width: 100%;
      height: 100%;
      border-radius: rem(9);
      object-fit: cover; // 确保图片比例正确
    }
  }
}

// 走马灯动画
@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%); // 移动一半距离，实现无缝循环
  }
}


.zy_copyright {
  background-image: url('https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/48598200-b2d1-48a6-9233-1c42a56c52ed.png');
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;

  .zy_copyright_title {
    color: #fff;
    font-size: rem(48);
    padding-top: rem(72);
    padding-bottom: rem(52);
    line-height: rem(84);
    font-weight: 500;
  }
}

.zy_copyright_info {
  padding: 0 rem(60);
  text-align: center;
}
.zy_copyright_detail {
  padding: 0 rem(48);
  height: rem(576);
  margin-top: rem(48);
  text-align: left;
  .zy_copyright_detail_desc {
    font-size: rem(36);
    line-height: rem(54);
    color: rgba(255, 255, 255, 0.85);
    margin-top: rem(36);
  }
}

::v-deep .tabs {
  display: inline-flex;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 1px;
    left: 0;
    height: 1px;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.1);
  }

  &__active-line {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    background-color: $mainActive;
    transition:
      transform 0.4s ease,
      width 0.4s ease;
  }

  &__item {
    display: inline-block;
    margin-left: rem(72);
    padding: rem(15) 0;
    font-size: rem(42);
    letter-spacing: 0.8px;
    color: rgba(255, 255, 255, 0.55);
    text-decoration: none;
    border: none;
    background-color: transparent;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    transition: all 0.25s;
    @include disable-tap-highlight;
    &_active,
    &:hover {
      color: #fff;
    }

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}

/* Android 特定样式 */
@supports not (-webkit-touch-callout: none) {
    .S .zy_copyright_title {
      font-weight: bold;
    }
}
</style>
